import { useMemo } from 'react';
import ActionTypes from '@utils/deviceActions';
import { DeviceActionProps } from '@components/Actions/ActionsModal/types';
import { useTranslation } from 'react-i18next';
import { IDevice } from '@pages/Assets/Inventory/types';
import rolesConstants from '@utils/rolesConstants';

interface NetworkResetPayloadProps {
  action: ActionTypes.NETWORK_RESET;
  devices: {
    msisdn: string;
  }[];
}

interface NetworkResetProps {
  devices: IDevice[];
  isUpload?: boolean;
}

const useNetworkReset = ({
  devices,
  isUpload,
}: NetworkResetProps): DeviceActionProps => {
  const { t } = useTranslation('device-actions');

  const payloadToSend = useMemo(
    (): NetworkResetPayloadProps => ({
      action: ActionTypes.NETWORK_RESET,
      devices: isUpload
        ? devices
        : devices?.map(device => ({
            msisdn: device.msisdn,
          })),
    }),
    [devices, isUpload],
  );

  return {
    steps: [],
    payloadToSend,
    title: t(`labels.common.${rolesConstants.NETWORK_RESET}`),
  };
};

export default useNetworkReset;
